import DialogActions from '../../../shared/components/DialogActions/DialogActions';
import DialogContent from '../../../shared/components/DialogContent/DialogContent';
import DialogTitle from '../../../shared/components/DialogTitle/DialogTitle';
import { useEffect, useState } from 'react';
import Dialog from './QuoteDialog';

const QuoteForceValueDialog = ({ open, kind, line, onClose, onConfirm }) => {
  const [value, setValue] = useState('');
  const [reason, setReason] = useState('');
  const [expiresAt, setExpiresAt] = useState('');

  useEffect(() => {
    if (!open) return;
    setValue(kind === 'price'
      ? line?.forcedUnitSellingPrice ?? line?.calculatedUnitSellingPrice ?? ''
      : line?.forcedCoefficient ?? line?.effectiveCoefficient ?? line?.marginCoefficient ?? '');
    setReason(line?.forceReason || '');
    setExpiresAt(line?.forceExpiresAt ? String(line.forceExpiresAt).slice(0, 16) : '');
  }, [open, kind, line]);

  const label = kind === 'price' ? 'prix' : 'coefficient';
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Forcer le {label}</DialogTitle>
      <DialogContent className="quote-force-dialog">
        <div className="quote-force-comparison">
          <span>Valeur calculée</span>
          <strong>{kind === 'price' ? line?.calculatedUnitSellingPrice : line?.calculatedCoefficient ?? line?.marginCoefficient}</strong>
        </div>
        <label>Nouvelle valeur<input autoFocus required type="number" min="0" step="0.0001" value={value} onChange={(e) => setValue(e.target.value)} /></label>
        <label>Motif obligatoire<textarea required value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ex. alignement commercial" /></label>
        <label>Expiration éventuelle<input type="datetime-local" value={expiresAt} onChange={(e) => setExpiresAt(e.target.value)} /></label>
      </DialogContent>
      <DialogActions>
        <button type="button" className="basic-button" onClick={onClose}>Annuler</button>
        <button
          type="button"
          className="basic-button active"
          disabled={!value || reason.trim().length < 3}
          onClick={() => onConfirm({ value, reason: reason.trim(), expiresAt: expiresAt || null })}
        >
          Confirmer le forçage
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default QuoteForceValueDialog;
